import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatPaginator,
  MatDatepickerInputEvent,
  MatSort,
} from "@angular/material";
import { AppService } from "src/_services/app.service";
import * as moment from "moment";
import { ActivatedRoute, Router } from "@angular/router";
import { GameReportByMarket } from "src/_models";
import { Location } from "@angular/common";

@Component({
  selector: "gm-events-level",
  templateUrl: "./gr-events-level.component.html",
  styleUrls: ["../game-report.component.scss"],
})
export class GmRepEventsLevelComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort) sort: MatSort;
  datalistDisplayedColumns: string[] = [
    "MarketName",
    "TotalBets",
    "TotalAmount",
    "TotalCommission",
    "TotalCancel",
    "TotalLost",
    "TotalWon",
    "ToTalCashedOut",
    "CashedOutAmount",
    "TotalProfit",
  ];
  providers: any = [];
  datalist = new MatTableDataSource<GameReportByMarket>();
  filterUsers = [];
  users = [];
  providerId = "";
  sportName = null;
  sportId = "";
  userID: string = "";
  operatorId = "";
  origin = [];
  prTitle = "";
  category = "";
  subProvider = "";
  competitionId = null;
  eventID = null;
  userName: any;
  eventName = null;
  selected: any = { startDate: 0, endDate: 0 };
  competitionName: string = "";
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };
  constructor(
    private appService: AppService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location
  ) {}

  ngOnInit() {
    this.providerId = this.activatedRoute.snapshot.params.providerId;
    this.sportId = this.activatedRoute.snapshot.params.sportId;
    this.competitionId = this.activatedRoute.snapshot.params.competitionId;
    this.eventID = this.activatedRoute.snapshot.params.eventId;

    this.activatedRoute.queryParams.subscribe((params) => {
      this.operatorId = params.operatorId;
      this.providerId = params.providerId;
      this.sportName = params.sportName;
      this.origin = params.origin;
      this.category = params.category;
      this.subProvider = params["subProvider"];
      this.eventName = params.eventName;
      this.userID = params.userId;
      this.userName = params.userName;

      this.selected = {
        startDate:
          params.startTime !== "0"
            ? new Date(params.startTime * 1000)
            : new Date(),
        endDate:
          params.endTime !== "0" ? new Date(params.endTime * 1000) : new Date(),
      };
      this.competitionName = params.competitionName;
      if (this.providerId && this.competitionId) {
        this.getReportData();
      }
      let lowerCaseOrigins = this.origin.map(item => item.toLowerCase());
      this.prTitle = lowerCaseOrigins.length > 0 ? lowerCaseOrigins.join(', ') : "";
    });
  }

  ngAfterViewInit() {
    this.datalist.sort = this.sort;
    this.datalist.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'MarketName': return item.marketName;
        case 'TotalAmount': return item.totalAmount;
        case 'TotalBets': return item.totalBets;
        case 'TotalCommission':return item.totalCommission ;
        case 'TotalCancel':return item.totalCancel;
        case 'TotalLost':return item.totalLost;
        case 'TotalWon':return item.totalWon;
        case 'TotalProfit':return item.totalProfit;
        case 'ToTalCashedOut':return item.totalCashOut;
        case 'CashedOutAmount':return item.cashOutAmount;
        default: return item[property];
      }
    };
  }

  goBackToCompetitionLevel = () => {
    this.router.navigate(
      [
        `reports/game_report/${this.providerId}/${this.sportId}/${this.competitionId}`,
      ],
      {
        queryParams: {
          operatorId: this.operatorId,
          providerId: this.providerId,
          sportId: this.sportId,
          origin: this.origin ? this.origin : [],
          category: this.category ? this.category : "",
          subProvider : this.subProvider ? this.subProvider : "",
          sportName: this.sportName,
          competitionName: this.competitionName,
          competitionId: this.competitionId,
          userId: this.userID ? this.userID : "",
          userName: this.userName ? this.userName : "",

          startTime:
            this.selected.startDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.startDate).getTime() / 1000).toFixed(
                    0
                  )
                ),
          endTime:
            this.selected.endDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.endDate).getTime() / 1000).toFixed(0)
                ),
        },
      }
    );
  };

  goBackToSportLevel = () => {
    this.router.navigate(
      [`reports/game_report/${this.providerId}/${this.sportId}`],
      {
        queryParams: {
          providerId: this.providerId,
          userId: this.userID ? this.userID : "",
          sportId: this.sportId,
          sportName: this.sportName,
          origin: this.origin ? this.origin : [],
          category: this.category ? this.category : "",
          subProvider : this.subProvider ? this.subProvider : "",
          userName: this.userName ? this.userName : "",
          operatorId: this.operatorId,
          startTime:
            this.selected.startDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.startDate).getTime() / 1000).toFixed(
                    0
                  )
                ),
          endTime:
            this.selected.endDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.endDate).getTime() / 1000).toFixed(0)
                ),
        },
      }
    );
  };

  goBackToProviderLevel = () => {
    this.router.navigate([`reports/game_report/${this.providerId}`], {
      queryParams: {
        providerId: this.providerId,
        userId: this.userID ? this.userID : "",
        userName: this.userName ? this.userName : "",
        operatorId: this.operatorId,
        origin: this.origin ? this.origin : [],
        category: this.category ? this.category : "",
        subProvider : this.subProvider ? this.subProvider : "",
        startTime:
          this.selected.startDate !== null
            ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
            : 0,
        endTime:
          this.selected.endDate !== null
            ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
            : 0,
      },
    });
  };

  goBackToGameLevel = () => {
    this.router.navigate([`reports/game_report/`]);
  };

  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.selected.startDate !== null) {
      this.getReportData();
    }
  };

  getReportData = () => {
    try {
      let startDate, endDate;
      this.activatedRoute.queryParams.subscribe((params) => {
        (startDate = params.startTime), (endDate = params.endTime);
      });
      let filters = {
        userId: this.userID ? this.userID : null,
        providerId: this.providerId,
        sportId: this.sportId,
        eventId: this.eventID,
        competitionId: this.competitionId,
        origin: this.origin ? this.origin : [],
        category: this.category ? this.category : "",
        subProvider : this.subProvider ? this.subProvider : "",
        operatorId: this.operatorId,
        startTime:
          startDate === "0"
            ? 0
            : parseInt(
                (new Date(this.selected.startDate).getTime() / 1000).toFixed(0)
              ),
        endTime:
          endDate === "0"
            ? 0
            : parseInt(
                (new Date(this.selected.endDate).getTime() / 1000).toFixed(0)
              ),
      };

      this.appService.getGMReportByMarketLevel(filters).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.datalist.data = res.marketGamesReports
        }
      });
    } catch (err) {}
  };

  goToMarketLevel = (row: GameReportByMarket) => {
    let startDate, endDate;
    console.log(row.marketId);
    this.activatedRoute.queryParams.subscribe((params) => {
      (startDate = params.startTime), (endDate = params.endTime);
    });
    this.router.navigate(
      [
        `reports/game_report/${this.providerId}/${this.sportId}/${this.competitionId}/${this.eventID}/${row.marketId}`,
      ],
      {
        queryParams: {
          providerId: this.providerId,
          eventName: this.eventName,
          marketName: row.marketName,
          origin: this.origin ? this.origin : [],
          category: this.category ? this.category : "",
          subProvider : this.subProvider ? this.subProvider : "",
          // sportId: this.sportId,
          operatorId: this.operatorId,
          sportName: this.sportName,
          competitionId: this.competitionId,
          competitionName: this.competitionName,
          userId: this.userID ? this.userID : "",
          userName: this.userName ? this.userName : "",
          startTime:
            startDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.startDate).getTime() / 1000).toFixed(
                    0
                  )
                ),
          endTime:
            endDate === "0"
              ? 0
              : parseInt(
                  (new Date(this.selected.endDate).getTime() / 1000).toFixed(0)
                ),
        },
      }
    );
  };
}
